module.exports = __webpack_public_path__ + "img/qijian-yuangong.df5c1f21.svg";